/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import React from "react";
import { constructUrl, setUrlPath } from "../Authenticator/utils";
import Dimmer from "semantic-ui-react/dist/commonjs/modules/Dimmer/Dimmer";
import { Loader } from "semantic-ui-react";
import { useHistory } from "react-router-dom";
import ConfirmationDialog from "../ConfirmationDialog";
import { useTranslation } from "react-i18next";

interface MonitorProps {
  plan?: string;
}

const Monitor: React.FC<MonitorProps> = ({ plan }) => {
  const { t } = useTranslation("common");
  const history = useHistory();
  if (plan === "expired") {
    return (
      <ConfirmationDialog
        title={t("account_expired")}
        message={t("please_upgrade_monitor")}
        onOk={() => history.push("/")}
      />
    );
  }

  const redirectToMonitor = () => {
    setUrlPath("/");
    window.location.href = `${constructUrl("monitor")}/`;
  };

  redirectToMonitor();
  return (
    <Dimmer active>
      <Loader active size="large">
        {t("please_wait")}
      </Loader>
    </Dimmer>
  );
};

export default Monitor;
